import React, { useState, useEffect, useMemo } from 'react';
import {
  formatNumberDecimal,
  KTSVG,
  SimpleAlert,
} from '../../../../_mexablock/helpers';
import { ProgressDash } from '../../../../_mexablock/helpers/components/ProgressDashboard';
import { useGetAllIndicators } from '../../../modules/profile/hooks/profileHook';
import { useSelectCuentas } from '../hooks/DashboardHook';
import {
  downloadPDF as pdfActivaciones,
  downloadExcel as excelActivaciones,
} from '../../../service/reportes/Activaciones';
import {
  downloadPDF as pdfPortability,
  downloadExcel as excelPortability,
} from '../../../service/reportes/Portability';
import {
  downloadPDF as pdfRecharge,
  downloadExcel as excelRecargas,
} from '../../../service/reportes/Recargas';
interface IndicatorsData {
  activations: number;
  activations_number: number;
  portabilities: number;
  portabilities_number: number;
  recharges: number;
  recharges_number: number;
  globalTotal: number;
  oldest_year?: number;
}

type Props = {
  filterDate: any;
};

const Indicators: React.FC<Props> = ({ filterDate }) => {
  const [reloadGrid] = useState(Math.random() * 40);
  const [dataIndicators, setDataIndicators] = useState<IndicatorsData | null>(
    null
  );
  const [loadingExcel, setLoadingExcel] = useState<{ [key: number]: boolean }>(
    {}
  );
  const [loadingPDF, setLoadingPDF] = useState<{ [key: number]: boolean }>({});
  const { data } = useSelectCuentas(reloadGrid);
  
  // Usar useMemo para estabilizar el objeto de filtros
  const initFilterValues = useMemo(() => ({
    init_date: filterDate.init_date,
    end_date: filterDate.end_date,
  }), [filterDate.init_date, filterDate.end_date]);
  
  const { dataIndicators: initialIndicators } = useGetAllIndicators(
    reloadGrid,
    initFilterValues
  );

  const {
    activations = 0,
    activations_number = 0,
    portabilities = 0,
    portabilities_number = 0,
    recharges = 0,
    recharges_number = 0,
    globalTotal = 0,
  } = dataIndicators || {};

  const percentageActivations =
    globalTotal > 0
      ? Number(((activations / globalTotal) * 100).toFixed(2))
      : 0;
  const percentagePortabilities =
    globalTotal > 0
      ? Number(((portabilities / globalTotal) * 100).toFixed(2))
      : 0;
  const percentageRecharges =
    globalTotal > 0 ? Number(((recharges / globalTotal) * 100).toFixed(2)) : 0;

  useEffect(() => {
    if (initialIndicators) {
      setDataIndicators(initialIndicators);
    }
  }, [initialIndicators]);

  const obtenerPeriodo = () => {
    const fecha = new Date();
    const mes = fecha.toLocaleDateString('es-ES', { month: 'long' });
    const año = fecha.getFullYear();
    return `${mes.charAt(0).toUpperCase() + mes.slice(1)} ${año}`;
  };

  const handleDownloadExcelAct = async (TypeReport: number) => {
    setLoadingExcel((prev) => ({ ...prev, [TypeReport]: true }));
    try {
      if (TypeReport === 1) await excelActivaciones(initFilterValues);
      if (TypeReport === 2) await excelPortability(initFilterValues);
      if (TypeReport === 3) await excelRecargas(initFilterValues);
    } catch (error: any) {
      SimpleAlert(
        error.message || 'Error al descargar el Excel',
        4000,
        'error'
      );
    } finally {
      setLoadingExcel((prev) => ({ ...prev, [TypeReport]: false }));
    }
  };

  const handleDownloadPDFAct = async (TypeReport: number) => {
    setLoadingPDF((prev) => ({ ...prev, [TypeReport]: true }));
    try {
      if (TypeReport === 1) await pdfActivaciones(initFilterValues);
      if (TypeReport === 2) await pdfPortability(initFilterValues);
      if (TypeReport === 3) await pdfRecharge(initFilterValues);
    } catch (error: any) {
      SimpleAlert(error.message || 'Error al descargar el PDF', 4000, 'error');
    } finally {
      setLoadingPDF((prev) => ({ ...prev, [TypeReport]: false }));
    }
  };

  return (
    <>
      {/* {!dataIndicators ? null : ( */}
      <div className="container-fluid px-0">
        <div className="row g-2 g-lg-3 justify-content-between w-100 mb-9">
          <div className="col">
            <div className="card card-flush">
              <div className="card-header pt-5">
                <div className="card-title d-flex flex-column">
                  <span className="text-primary pb-2 fw-semibold fs-5">
                    Balance
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="fs-1 fw-semibold text-gray-500 me-1 align-self-start">
                      $
                    </span>
                    <span className="fs-1 fw-bold text-gray-900 me-2 lh-1 ls-n2">
                      {formatNumberDecimal(globalTotal ? globalTotal : 0)}
                    </span>
                  </div>
                  <span className="fs-9 text-gray-600">
                    Periodo: {obtenerPeriodo()}
                  </span>
                  <div className="d-flex gap-3 w-100 flex-grow-1 pt-2">
                    <ProgressDash
                      porcentaje={
                        percentageActivations ? percentageActivations : 0
                      }
                      color="#65558f"
                    />
                    <ProgressDash
                      porcentaje={
                        percentagePortabilities ? percentagePortabilities : 0
                      }
                      color="#65558fcc"
                    />
                    <ProgressDash
                      porcentaje={percentageRecharges ? percentageRecharges : 0}
                      color="#65558f99"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col">
            <div className="card card-flush">
              <div className="card-header pt-5">
                <div className="card-title d-flex flex-column">
                  <span className="text-primary pb-2 fw-semibold fs-5">
                    Activaciones
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="fs-1 fw-semibold text-gray-500 me-1 align-self-start">
                      $
                    </span>
                    <span className="fs-1 fw-bold text-gray-900 me-2 lh-1 ls-n2">
                      {formatNumberDecimal(activations ? activations : 0)}
                    </span>
                  </div>
                  <span className="fs-9 text-gray-600">
                    <span className="text-success fw-bolder">
                      {activations_number ? activations_number : 0}
                    </span>{' '}
                    realizadas exitosamente
                  </span>
                  <div className="d-flex rounded mt-3">
                    <button
                      className="btn btn-sm btn-primary fs-10 d-flex align-items-center gap-1"
                      disabled={loadingExcel[1]}
                      onClick={() => handleDownloadExcelAct(1)}
                    >
                      {loadingExcel[1] &&
                      Array.isArray(data) &&
                      data.length > 0 ? (
                        <span className="indicator-progress">
                          Descargando...
                          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                      ) : (
                        <>
                          <KTSVG
                            path="/media/icons/duotune/files/fil029.svg"
                            className="svg-icon-5 svg-icon-gray-500"
                          />
                          <span>Descargar</span>
                        </>
                      )}
                    </button>

                    <button
                      className="btn btn-sm btn-primary fs-10 d-flex align-items-center gap-1 ms-1"
                      disabled={loadingPDF[1]}
                      onClick={() => handleDownloadPDFAct(1)}
                    >
                      {loadingPDF[1] &&
                      Array.isArray(data) &&
                      data.length > 0 ? (
                        <span className="indicator-progress">
                          Descargando...
                          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                      ) : (
                        <>
                          <KTSVG
                            path="/media/icons/duotune/files/fil030.svg"
                            className="svg-icon-5 svg-icon-gray-500"
                          />
                          <span>Descargar</span>
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col">
            <div className="card card-flush">
              <div className="card-header pt-5">
                <div className="card-title d-flex flex-column">
                  <span className="text-primary pb-2 fw-semibold fs-5">
                    Portabilidad
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="fs-1 fw-semibold text-gray-500 me-1 align-self-start">
                      $
                    </span>
                    <span className="fs-1 fw-bold text-gray-900 me-2 lh-1 ls-n2">
                      {formatNumberDecimal(portabilities ? portabilities : 0)}
                    </span>
                  </div>
                  <span className="fs-9 text-gray-600">
                    <span className="text-success fw-bolder">
                      {portabilities_number ? portabilities_number : 0}
                    </span>{' '}
                    realizadas exitosamente
                  </span>
                  <div className="d-flex rounded mt-3">
                    <button
                      className="btn btn-sm btn-primary fs-10 d-flex align-items-center gap-1"
                      disabled={loadingExcel[2]}
                      onClick={() => handleDownloadExcelAct(2)}
                    >
                      {loadingExcel[2] &&
                      Array.isArray(data) &&
                      data.length > 0 ? (
                        <span className="indicator-progress">
                          Descargando...
                          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                      ) : (
                        <>
                          <KTSVG
                            path="/media/icons/duotune/files/fil029.svg"
                            className="svg-icon-5 svg-icon-gray-500 me-1"
                          />
                          Descargar
                        </>
                      )}
                    </button>
                    <button
                      className="btn btn-sm btn-primary fs-10 d-flex align-items-center gap-1 ms-1"
                      disabled={loadingPDF[2]}
                      onClick={() => handleDownloadPDFAct(2)}
                    >
                      {loadingPDF[2] &&
                      Array.isArray(data) &&
                      data.length > 0 ? (
                        <span className="indicator-progress">
                          Descargando...
                          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                      ) : (
                        <>
                          <KTSVG
                            path="/media/icons/duotune/files/fil030.svg"
                            className="svg-icon-5 svg-icon-gray-500 me-1"
                          />
                          Descargar
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col">
            <div className="card card-flush">
              <div className="card-header pt-5">
                <div className="card-title d-flex flex-column">
                  <span className="text-primary pb-2 fw-semibold fs-5">
                    Recargas
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="fs-1 fw-semibold text-gray-500 me-1 align-self-start">
                      $
                    </span>
                    <span className="fs-1 fw-bold text-gray-900 me-2 lh-1 ls-n2">
                      {formatNumberDecimal(recharges ? recharges : 0)}
                    </span>
                  </div>
                  <span className="fs-9 text-gray-600">
                    <span className="text-success fw-bolder">
                      {recharges_number ? recharges_number : 0}
                    </span>{' '}
                    realizadas exitosamente
                  </span>
                  <div className="d-flex rounded mt-3">
                    <button
                      className="btn btn-sm btn-primary fs-10 d-flex align-items-center gap-1"
                      disabled={loadingExcel[3]}
                      onClick={() => handleDownloadExcelAct(3)}
                    >
                      {loadingExcel[3] &&
                      Array.isArray(data) &&
                      data.length > 0 ? (
                        <span className="indicator-progress">
                          Descargando...
                          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                      ) : (
                        <>
                          <KTSVG
                            path="/media/icons/duotune/files/fil029.svg"
                            className="svg-icon-5 svg-icon-gray-500 me-1"
                          />
                          Descargar
                        </>
                      )}
                    </button>
                    <button
                      className="btn btn-sm btn-primary fs-10 d-flex align-items-center gap-1 ms-1"
                      disabled={loadingPDF[3]}
                      onClick={() => handleDownloadPDFAct(3)}
                    >
                      {loadingPDF[3] &&
                      Array.isArray(data) &&
                      data.length > 0 ? (
                        <span className="indicator-progress">
                          Descargando...
                          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                      ) : (
                        <>
                          <KTSVG
                            path="/media/icons/duotune/files/fil030.svg"
                            className="svg-icon-5 svg-icon-gray-500 me-1"
                          />
                          Descargar
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* )} */}
    </>
  );
};
export default Indicators;
